import { cn } from '@/utils/tailwind';
import { VariantProps, cva } from 'class-variance-authority';

const badgeVariants = cva('flex items-center justify-center w-fit relative', {
  variants: {
    variant: {
      primary: 'text-point-500 bg-point-100',
      gray: 'text-gr-600 bg-gr-100',
      red: 'text-statusRed-400 bg-statusRed-100',
      blue: 'text-statusBlue-400 bg-statusBlue-100',
      green: 'text-statusGreen-400 bg-statusGreen-100',
    },
    height: {
      '30': 'h-[30px] Body5M14 rounded-[8px]',
      '26': 'h-[26px] Caption2S12 rounded-[8px]',
      '22': 'h-[22px] Caption2S12 rounded-[8px]',
    },
    width: {
      '8': 'px-[8px]',
      '6': 'px-[6px]',
      '4': 'px-[4px]',
    },
  },
  defaultVariants: {
    height: '30',
    variant: 'primary',
    width: '8',
  },
});
export type BadgeProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof badgeVariants> & {
    hasFurtherAction?: boolean;
  };

const Badge = ({
  className,
  variant,
  height,
  width,
  children,
  hasFurtherAction = false,
  ...props
}: BadgeProps) => {
  return (
    <div className={cn(badgeVariants({ variant, height, width }), className)} {...props}>
      {children}
      {hasFurtherAction && (
        <div
          className={cn(
            'absolute right-0 top-0 bg-statusRed-400',
            height === '30' ? 'h-[6px] w-[6px] rounded-[3px]' : 'h-[4px] w-[4px] rounded-[2px]',
          )}
        ></div>
      )}
    </div>
  );
};

export default Badge;
